import BeveledBoxSvg623x660 from './BeveledBoxSvg623x660';

export default BeveledBoxSvg623x660;
export { BeveledBoxSvg623x660 };
